export default __webpack_public_path__ + "assets/img/authentication-layout.dfb8ebb.jpg";